export default __webpack_public_path__ + "static/media/deutz-fahr-agrotron-120.7da7f43a.jpg";